"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconButtonSlots = exports.default = exports.IconButton = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _iconButtonClasses = _interopRequireWildcard(require("./iconButtonClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity -- many options */

const getIconButtonSlots = ownerState => {
  const {
    color,
    size,
    variant,
    edge,
    disabled
  } = ownerState;
  return {
    root: ['root', variant, `${variant}${(0, _utils.capitalize)(color)}`, `size${(0, _utils.capitalize)(size)}`, `${variant}Size${(0, _utils.capitalize)(size)}`, color === 'inherit' && 'colorInherit', (edge === 'end' || edge === 'start') && `edge${(0, _utils.capitalize)(edge)}`, disabled && 'disabled']
  };
};
exports.getIconButtonSlots = getIconButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getIconButtonSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};

// because of possibility of failing accessibility tests, inherit color is not supported and in this version is overridden

const IconButtonRoot = (0, _material.styled)(_material.ButtonBase, {
  name: 'MuiOriIconButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0, _utils.capitalize)(ownerState.color)}`], styles[`size${(0, _utils.capitalize)(ownerState.size)}`], styles[`${ownerState.variant}Size${(0, _utils.capitalize)(ownerState.size)}`], (ownerState.edge === 'end' || ownerState.edge === 'start') && styles[`edge${(0, _utils.capitalize)(ownerState.edge)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disabled && styles.disabled],
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: '2.4rem',
  padding: 6,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: theme.palette.action.active,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  // contained
  ...(ownerState.variant === 'contained' && {
    [`&.${_iconButtonClasses.default.disabled}`]: {
      color: theme.palette.default.light,
      background: theme.palette.grey[200]
    }
  }),
  ...(ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText,
    '&:hover': {
      backgroundColor: theme.palette[ownerState.color].dark,
      color: theme.palette[ownerState.color].contrastText,
      '@media (hover: none)': {
        backgroundColor: theme.palette[ownerState.color].main
      }
    }
  }),
  // contained default
  ...(ownerState.variant === 'contained' && ownerState.color === 'default' && {
    backgroundColor: theme.palette.default.contrastText,
    color: theme.palette.default.main,
    boxShadow: theme.shadows[2],
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.default.dark,
      backgroundColor: theme.palette.default.contrastText,
      boxShadow: theme.shadows[3],
      '@media (hover: none)': {
        boxShadow: theme.shadows[2]
      }
    },
    '&:active': {
      boxShadow: theme.shadows[8]
    },
    [`&.${_iconButtonClasses.default.disabled}`]: {
      color: theme.palette.grey[400],
      backgroundColor: theme.palette[ownerState.color].contrastText,
      boxShadow: theme.shadows[2]
    }
  }),
  // contained primary (and obsolete bannerButton and inherit)
  ...(ownerState.variant === 'contained' && (ownerState.color === 'bannerButton' || ownerState.color === 'inherit') && {
    backgroundColor: theme.palette.default.dark,
    color: theme.palette.default.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.grey.A700,
      color: theme.palette.default.contrastText,
      '@media (hover: none)': {
        backgroundColor: theme.palette.grey.A700,
        color: theme.palette.default.contrastText
      }
    },
    '&:active': {
      background: theme.palette.grey.A700
    }
  }),
  // contained secondary
  ...(ownerState.variant === 'contained' && ownerState.color === 'secondary' && {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.grey[300],
      '@media (hover: none)': {
        backgroundColor: theme.palette.grey[100]
      }
    }
  }),
  // outlined
  // default and inherit are used ... all will become same as secondary
  ...(ownerState.variant === 'outlined' && {
    padding: 4,
    border: '1px solid',
    color: theme.palette.default.dark,
    borderColor: theme.palette.default.dark,
    '&:hover': {
      color: theme.palette.default.dark,
      borderColor: theme.palette.default.dark,
      background: theme.palette.grey[200]
    },
    [`&.${_iconButtonClasses.default.disabled}`]: {
      color: theme.palette.default.light,
      background: theme.palette.grey[200],
      borderColor: theme.palette.grey[200]
    }
  }),
  // primary outlined is used for black button ... regular primary button
  ...(ownerState.variant === 'outlined' && ownerState.color === 'primary' && {
    backgroundColor: theme.palette.default.dark,
    color: theme.palette.default.contrastText,
    border: 0,
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.grey.A700,
      color: theme.palette.default.contrastText,
      border: 0,
      '@media (hover: none)': {
        backgroundColor: theme.palette.grey.A700,
        color: theme.palette.default.contrastText,
        border: 0
      }
    },
    '&:active': {
      background: theme.palette.grey.A700
    }
  }),
  // text
  ...(ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: theme.palette[ownerState.color].dark,
    '&:hover': {
      backgroundColor: (0, _material.alpha)(theme.palette[ownerState.color].dark, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${_iconButtonClasses.default.disabled}`]: {
      color: theme.palette.default.light,
      background: theme.palette.grey[200]
    }
  }),
  ...(ownerState.variant === 'text' && (ownerState.color === 'primary' || ownerState.color === 'secondary' || ownerState.color === 'bannerButton' || ownerState.color === 'warning' || ownerState.color === 'inherit') && {
    color: theme.palette.default.dark,
    '&:hover': {
      backgroundColor: (0, _material.alpha)(theme.palette.default.dark, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${_iconButtonClasses.default.disabled}`]: {
      color: theme.palette.default.light,
      background: theme.palette.grey[200]
    }
  }),
  ...(ownerState.edge === 'start' && {
    marginLeft: ownerState.size === 'small' ? -3 : -12
  }),
  ...(ownerState.edge === 'end' && {
    marginRight: ownerState.size === 'small' ? -3 : -12
  }),
  ...(ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '3px',
    fontSize: '1.4rem'
  }),
  ...(ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '2px',
    fontSize: '1.4rem'
  }),
  ...(ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '3px',
    fontSize: '1.4rem'
  }),
  ...(ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '9px',
    fontSize: '2.7rem'
  }),
  ...(ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '8px',
    fontSize: '2.7rem'
  }),
  ...(ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '9px',
    fontSize: '2.7rem'
  }),
  ...(ownerState.loading && {
    pointerEvents: 'none',
    [`& .${_material.circularProgressClasses.root}`]: {
      height: '18px',
      width: '18px',
      padding: '3px'
    }
  }),
  ...(ownerState.loading && ownerState.size === 'small' && {
    [`& .${_material.circularProgressClasses.root}`]: {
      height: '8px',
      width: '8px',
      padding: '3px'
    }
  }),
  ...(ownerState.loading && ownerState.size === 'large' && {
    [`& .${_material.circularProgressClasses.root}`]: {
      height: '21px',
      width: '21px',
      padding: '3px'
    }
  })
}), ({
  ownerState
}) => ({
  ...(ownerState.disableElevation && {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none'
    },
    [`&.${_iconButtonClasses.default.focusVisible}`]: {
      boxShadow: 'none'
    },
    '&:active': {
      boxShadow: 'none'
    },
    [`&.${_iconButtonClasses.default.disabled}`]: {
      boxShadow: 'none'
    }
  })
}));
const getIcon = ({
  children,
  hoverIcon,
  isHovering,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
      size: "-",
      color: "inherit"
    });
  }
  if (Boolean(hoverIcon) && isHovering) {
    return hoverIcon;
  }
  return children;
};
const IconButton = exports.IconButton = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriIconButton'
  });
  const {
    children,
    className,
    color = 'primary',
    disabled = false,
    disableFocusRipple = false,
    hoverIcon,
    loading,
    size = 'medium',
    edge = false,
    type,
    variant = 'outlined',
    disableElevation,
    ...other
  } = props;
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const handleMouseOver = (0, _react.useCallback)(() => {
    setIsHovering(true);
  }, []);
  const handleMouseOut = (0, _react.useCallback)(() => {
    setIsHovering(false);
  }, []);
  const ownerState = {
    ...props,
    color,
    edge,
    disabled,
    disableFocusRipple,
    size,
    type,
    variant,
    disableElevation
  };
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconButtonRoot, {
    ref: ref,
    centerRipple: true,
    className: (0, _clsx.default)(classes.root, className),
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ownerState: ownerState,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    ...other,
    children: getIcon({
      children,
      hoverIcon,
      isHovering,
      loading
    })
  });
});
var _default = exports.default = IconButton;
